import * as React from 'react'

import Control from './Control'
import { Container, ContentContainer } from './Section.styles'

interface IProps {
  innerBody?: React.ReactNode
  children: React.ReactNode
}

export default function Section(props: IProps) {
  const { children, innerBody } = props
  const [open, setOpen] = React.useState(false)

  return (
    <Container>
      <ContentContainer>{open ? innerBody : children}</ContentContainer>
      {innerBody && <Control open={open} onChange={setOpen} />}
    </Container>
  )
}
